import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Scroll.sass'

class Scroll extends Component {
  handleScroll = event => {
    if (this.props.onScroll) {
      this.props.onScroll(event.target.scrollTop)
    }
  }

  render () {
    return (
      <div className='scroll-container'>
        <div
          onScroll={this.handleScroll}
          style={{ right: this.props.isVisible ? 0 : -15 }}
          className='scroll-inner'
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Scroll

Scroll.propTypes = {
  isVisible: PropTypes.bool,
  children: PropTypes.object,
  onScroll: PropTypes.func
}
